var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCantorLogoRvbC06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 364 364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#1a1a1a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Cantor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.21,197.61l-39.49,39.45a10.81,10.81,0,0,1-14.76,0l-47.71-47.67a10.61,10.61,0,0,1,0-14.79L187,126.92a10.84,10.84,0,0,1,14.76,0l39,39,37.65-32.42L234.17,89.27a55.93,55.93,0,0,0-39.81-16.44h0a56,56,0,0,0-39.81,16.44L101.6,142.18a56.38,56.38,0,0,0,0,79.63l52.92,52.91a55.91,55.91,0,0,0,39.8,16.45h0a55.91,55.91,0,0,0,39.8-16.45l44.7-44.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCantorLogoRvbC06);
export default __webpack_public_path__ + "static/media/Cantor-logo-rvb-c-06.acf2b1e34470e6e869ff9af0e43449f2.svg";
export { ForwardRef as ReactComponent };